<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="thumb_down_alt_black_24dp 2" clip-path="url(#clip0_2001_23545)">
<path id="Vector" d="M2 21L4 21C4.55 21 5 20.55 5 20L5 11C5 10.45 4.55 10 4 10L2 10L2 21ZM21.83 13.88C21.94 13.63 22 13.36 22 13.08L22 12C22 10.9 21.1 10 20 10L14.5 10L15.42 5.35C15.47 5.13 15.44 4.89 15.34 4.69C15.11 4.24 14.82 3.83 14.46 3.47L14 3L7.59 9.41C7.21 9.79 7 10.3 7 10.83L7 18.66C7 19.95 8.05 21 9.34 21L17.44 21C18.15 21 18.8 20.63 19.16 20.03L21.83 13.88Z" fill=""/>
</g>
<defs>
<clipPath id="clip0_2001_23545">
<rect width="24" height="24" fill="white" transform="translate(24 24.5) rotate(-180)"/>
</clipPath>
</defs>
</svg>
